import { Pawn } from "./Pawn";

const MODES = {
  party: { band: "bg-flood text-cream", pawn: "cream" },
  daily: { band: "bg-gold text-ink", pawn: "duel" },
  duel: { band: "bg-duel text-ink", pawn: "gold" },
} as const;

interface ModeRulesCardProps {
  mode: keyof typeof MODES;
  title: string;
  steps: string[];
  isDark: boolean;
}

/** A game mode's rules, printed like the rules card from a board game box. */
export function ModeRulesCard({ mode, title, steps, isDark }: ModeRulesCardProps) {
  const { band, pawn } = MODES[mode];

  return (
    <section
      className={`overflow-hidden rounded-2xl border-[3px] border-ink shadow-board text-left ${isDark ? "bg-zinc-900" : "bg-white"}`}
    >
      <div
        className={`flex items-center justify-between gap-3 border-b-[3px] border-ink px-5 py-4 ${band}`}
      >
        <h3 className="font-display text-xl leading-tight uppercase">{title}</h3>
        <Pawn color={pawn} className="h-8 w-8 shrink-0" />
      </div>
      <ol className="flex flex-col gap-3 px-5 py-5">
        {steps.map((step, index) => (
          <li key={index} className="flex items-start gap-3">
            <span
              aria-hidden="true"
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-ink bg-ink font-display text-xs text-gold"
            >
              {index + 1}
            </span>
            <span
              className={`pt-0.5 text-[15px] leading-snug ${isDark ? "text-zinc-300" : "text-gray-700"}`}
            >
              {step}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
